<template>
  <div class="flex flex-col items-start gap-1">
    <LabelBadge
      :label="statusConfig.label"
      :color="statusConfig.color"
      :icon="statusConfig.icon"
      size="small"
      data-testid="check-validation-status-badge"
    />
    <!-- Marcadores secundários: qualificam a linha, não substituem o status. -->
    <LabelBadge
      v-if="isOverdue"
      :label="OVERDUE_BADGE.label"
      :color="OVERDUE_BADGE.color"
      :icon="OVERDUE_BADGE.icon"
      size="small"
      data-testid="check-validation-overdue-badge"
    />
    <LabelBadge
      v-if="isEditedSinceSubmit"
      :label="EDITED_SINCE_SUBMIT_BADGE.label"
      :color="EDITED_SINCE_SUBMIT_BADGE.color"
      :icon="EDITED_SINCE_SUBMIT_BADGE.icon"
      size="small"
      data-testid="check-validation-edited-badge"
    />
    <LabelBadge
      v-if="isEvidenceUnavailable"
      :label="EVIDENCE_UNAVAILABLE_BADGE.label"
      :color="EVIDENCE_UNAVAILABLE_BADGE.color"
      :icon="EVIDENCE_UNAVAILABLE_BADGE.icon"
      size="small"
      data-testid="check-validation-evidence-unavailable-badge"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import type { CheckValidationStatus } from '@/Network/Types/Responses/CheckValidationResponses'

import {
  EDITED_SINCE_SUBMIT_BADGE,
  EVIDENCE_UNAVAILABLE_BADGE,
  OVERDUE_BADGE,
  statusConfigFor
} from '../constants'

const props = withDefaults(
  defineProps<{
    status: CheckValidationStatus
    isOverdue?: boolean
    isEditedSinceSubmit?: boolean
    isEvidenceUnavailable?: boolean
  }>(),
  { isOverdue: false, isEditedSinceSubmit: false, isEvidenceUnavailable: false }
)

const statusConfig = computed(() => statusConfigFor(props.status))
</script>
